import type { ReviewEntityType } from '../slices/reviewsSearchFilters';

export default function getReviewFilterCount(entityType: ReviewEntityType, ratings: number[], activities: string[], months: number[]): number {
  return ratings.length + activities.length + months.length + (entityType !== 'reviews' ? 1 : 0);
}
